
export function asyncFetchExpenseAccounts(handler, errorHandler) {

    fetch("/api/v1/getExpenseAccounts")
        .then(response => response.json())
        .then(data => handler(data))
        .catch(error => errorHandler(error));
}

export function asyncFetchExpenseManifest(handler, errorHandler) {

    fetch("/api/v1/fetchExpenseManifest")
        .then(response => response.json())
        .then(data => handler(data))
        .catch(error => errorHandler(error));
}

export function asyncRequestProfitAndLoss(startDate, endDate, handler, errorHandler) {

    fetch("/api/v1/generateProfitAndLossReport?startDate="+startDate + "&endDate="+endDate)
        .then(response => response.json())
        .then(data => handler(data))
        .catch(error => errorHandler(error));
}

export function asyncRequestEbidtaPayload(year, handler, errorHandler) {

    fetch("/api/v1/generateEbidtaPayload?year="+year)
        .then(response => response.json())
        .then(data => handler(data))
        .catch(error => errorHandler(error));
}

export function asyncRequestCompanyInfo(handler, errorHandler) {
    fetch("/api/v1/queryCompanyInfo", {cache: "no-store"})
        .then(response => response.json())
        .then(data => handler(data))
        .catch(error => errorHandler(error));
}
